import { backendPoint } from "../config";
import { getCookie } from "../utils/cookie";

export const fetchGql = (query) => {
  const token = getCookie("dynos_plus_session");
  return fetch(backendPoint, {
    method: "POST",
    body: JSON.stringify({ query }),
    headers: {
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
};
